const TRAIN_KEY_MAP = {
  r: 'route',
  vid: 'v_id',
  vrid: 'v_route_id',
  vtid: 'v_trip_id',
  vst: 'v_start_time',
  vsid: 'v_stop_id',
  vt: 'v_timestamp',
  vcs: 'v_current_status',
  vcss: 'v_current_stop_sequence',
  tid: 'trip_id',
  rid: 'route_id',
  st: 'start_time',
  sid: 'stop_id',
  td: 'time_departure',
  ta: 'time_arrival',
  ls: 'last_stop',
  tst: 'time_start_trip',
  css: 'current_stop_sequence',
  cs: 'current_status',
};

export function renameTrainKeys(items = []) {
  return items.map((item) => {
    const renamed = {};
    Object.entries(item || {}).forEach(([key, value]) => {
      renamed[TRAIN_KEY_MAP[key] || key] = value;
    });
    return renamed;
  });
}

export function normalizeTrainResponse(rawResponse = {}) {
  const normalized = {};

  Object.entries(rawResponse || {}).forEach(([group, value]) => {
    try {
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;
      normalized[group] = renameTrainKeys(Array.isArray(parsed) ? parsed : []);
    } catch (error) {
      normalized[group] = [];
    }
  });

  return normalized;
}

export function flattenTrains(trainsByGroup = {}) {
  return Object.values(trainsByGroup).flatMap((items) => Array.isArray(items) ? items : []);
}

export function createTrainsByStopId(trainsByGroup = {}) {
  const byStopId = new Map();

  flattenTrains(trainsByGroup).forEach((train) => {
    if (!train?.stop_id) return;

    const list = byStopId.get(train.stop_id) || [];
    list.push(train);
    byStopId.set(train.stop_id, list);
  });

  return byStopId;
}

export function getActiveRoutesForStops(trainsByStopId, stopIds = [], nowMs = Date.now()) {
  const routes = {
    active: new Set(),
    N: new Set(),
    S: new Set(),
  };

  stopIds.forEach((stopId) => {
    const trains = trainsByStopId.get(stopId) || [];

    trains.forEach((train) => {
      const minutesAway = Math.round(((Number(train.time_arrival) * 1000 - nowMs) / 1000 / 60));
      if (minutesAway < -3 || !train.route_id) return;

      routes.active.add(train.route_id);
      if (train.dir === 'N') routes.N.add(train.route_id);
      if (train.dir === 'S') routes.S.add(train.route_id);
    });
  });

  return {
    active: [...routes.active],
    N: [...routes.N],
    S: [...routes.S],
  };
}
